import React from 'react';
import GlobalContextWrapper from 'utilities/GlobalContext/GlobalContext';
// eslint-disable-next-line import/order
import Routes from 'pages/Routes';
import { useAppHeight } from 'hooks/useAppHeight';
import AuthenticatedApp from './components/AuthenticatedApp';

export default function App() {
  useAppHeight();

  return (
    <AuthenticatedApp>
      <GlobalContextWrapper>
        <Routes />
      </GlobalContextWrapper>
    </AuthenticatedApp>
  );
}
